import React from "react";
import { AppBar, Icon, IconButton, Toolbar, Typography } from "@mui/material";
import CustomDialog from "src/components/dialogo/CustomDialog";
import FormularioDatosPersonales from "./FormularioDatosPersonales";

export interface ConfirmacionProps {
  mostrarConfirmacion: boolean;
  permitirCerrar?: boolean;
  setMostrarConfirmacion: (valor: boolean) => void;
}

const DialogoDatosPersonales= ({
  mostrarConfirmacion,
  permitirCerrar,
  setMostrarConfirmacion,
}: ConfirmacionProps) => {
  return (
    <CustomDialog
      mostrar={mostrarConfirmacion}
      onClose={() => setMostrarConfirmacion(false)}
      contenido={<FormularioDatosPersonales />}
      
      header={<AppBar sx={{ position: 'relative' }}>
      <Toolbar>
        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
          Actualización de datos personales
        </Typography>
        {permitirCerrar &&
        <IconButton
              edge="start"
              color="inherit"
              onClick={() => setMostrarConfirmacion(false)}
              aria-label="close"
            >
              <Icon>close</Icon>
            </IconButton>
        }
      </Toolbar>
    </AppBar>}
      tamanioMaximo="sm"
      pantallaCompleta
    />
  );
};

export default DialogoDatosPersonales;
